import * as React from "react";
import { SFC } from "react";
import { Button, Grid, Header } from "semantic-ui-react";
import Footer from "../components/footer/Footer";

const NotFoundContainer: SFC = () => {
  return (
    <>
      <Grid centered={ true } style={ {height: "100vh"} } verticalAlign="middle">
        <Grid.Column style={ {maxWidth: 450} }>
          <Header as="h2" color="grey" textAlign="center">
            ページが見つかりません
          </Header>
          <Header as="h3" color="grey" textAlign="center">
            ログインページよりログインしてください
          </Header>
          {/* eslint-disable-next-line no-restricted-globals */}
          <Button color="teal" fluid={ true } onClick={ () => location.href = "/" }>ログイン画面へ戻る</Button>
        </Grid.Column>
      </Grid>
      <Footer/>
    </>
  );
};

export default NotFoundContainer;
